import React, { Fragment } from 'react';
import { FormattedNumber } from 'react-intl';

import DataRow from 'components/Shared/DataRow/DataRow';
import SubscriptionDetails from 'components/Subscription/Details/SubscriptionDetails';
import { breakpoints } from 'styles/cp';
import { LineItems, LineItem } from 'types/Sale';

export interface Props {
  amount: number;
  taxAmount?: number;
  currency: string;
  lineItems: LineItems;
  isSubscriptionError: boolean;
  linesWithoutOTF?: LineItem[];
  onlyOTFLines?: LineItem[];
}

const SubscriptionPreviewWrapper: React.FC<Props> = ({
  amount,
  taxAmount,
  currency,
  lineItems,
  isSubscriptionError,
  linesWithoutOTF,
  onlyOTFLines,
}) => {
  const isDetailsOpened = !isSubscriptionError;
  const isTax = !!taxAmount && taxAmount > 0;

  return (
    <Fragment>
      <div className="card-sides">
        <div className="subscription-details">
          <DataRow
            regular={true}
            bold={true}
            margin="8px 0px"
            idValue="DETAILS"
            defaultMessage="Details"
            value=""
          />
          <SubscriptionDetails
            opened={isDetailsOpened}
            currency={currency}
            lines={lineItems}
            linesWithoutOTF={linesWithoutOTF}
            onlyOTFLines={onlyOTFLines}
          />
          {isTax && (
            <DataRow
              regular={true}
              margin="8px 0px"
              idValue={'SALES_TAX'}
              defaultMessage={'Sales Tax'}
              value={
                <FormattedNumber
                  value={isSubscriptionError ? 0 : taxAmount}
                  style="currency"
                  currency={currency}
                />
              }
            />
          )}
          {amount && (
            <DataRow
              bold={true}
              margin="8px 0px"
              idValue="INVOICE_TOTAL"
              defaultMessage="Total"
              value={
                <FormattedNumber
                  value={isSubscriptionError ? 0 : amount}
                  style="currency"
                  currency={currency}
                />
              }
            />
          )}
        </div>
      </div>
      <style jsx>{`
        .subscription-details {
          margin-top: 28px;

          @media screen and (max-width: ${breakpoints.md}) {
            margin: 28px 0;
          }
        }
      `}</style>
    </Fragment>
  );
};

export default SubscriptionPreviewWrapper;
